import {cloneDeep, get} from 'lodash';
import {getNumber, getString, resetObjectValues} from 'Core/helpers/data';
import {ManageVideosItemDataObject} from "../dataObjects";
import * as languageDataMap from 'Language/dataMap';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ManageVideosItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ManageVideosItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'title'),
		getString(result, 'description'),
		getString(result, 'linkEmbeded'),
		languageDataMap.input(get(result, 'languageData')),
		getNumber(result, 'displayOrdinal'),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {ManageVideosItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep(inputData);

	result = {
		id: result.id,
		name: result.name,
		title: result.title,
		description: result.description,
		linkEmbeded: result.link,
		languageId: languageDataMap.output(result.language),
		displayOrdinal: result.ordinal,
	};
	
	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}